import { Component, ViewChild, TemplateRef, OnInit, Input, ChangeDetectorRef, ViewContainerRef, AfterViewInit, ElementRef } from '@angular/core';
import _moment from 'proxies/dayjs';
import { isSameDay, isSameMonth } from 'date-fns';
import { Subject } from 'rxjs';
import { CalendarDateFormatter, CalendarEvent, CalendarEventTitleFormatter, CalendarView } from 'angular-calendar';
import { SmartModalService, ModalSize } from '../../services/smart-modal.service';
import { BaseService } from '../../shared/services/base.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilService } from '../../services/util.service';
import { CalendarEventDetailComponent } from './calendar-event-detail/calendar-event-detail.component';
import { AlertsService } from '../../services/alerts.service';
import { LoaderService } from '../../services/loader.service';
import { DialogConfig } from '../dialog/dialog-config';
import { CustomEventTitleFormatter } from './providers/custom-event-title.provider';
import { CommunicationService } from '../../services/communication.service';
import { CustomDateFormatter } from './providers/custom-date-formatter.provider';
import { DialogModalSize, DialogRef } from '../dialog/dialog-ref';
import { DialogService } from '../dialog/dialog.service';
import { SearchPatientComponent } from '../misc/searchPatient/search-patient.component';
import { AppService } from '../../shared/services/app.service';
import { AsideBarService } from '../../services/asideBar.service';
@Component({
    selector: 'kx-event-calendar',
    templateUrl: './event-calendar.component.html',
    styleUrls: ['./event-calendar.component.scss'],
    providers: [
        {
            provide: CalendarEventTitleFormatter,
            useClass: CustomEventTitleFormatter,
        },
        {
            provide: CalendarDateFormatter,
            useClass: CustomDateFormatter,
        },
    ],
    standalone: false
})
export class EventCalendarComponent implements OnInit {
    @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;
    @ViewChild('customComponent', { read: ViewContainerRef }) customComponent: ViewContainerRef;
    @Input() input: any;
    @ViewChild('viewData') viewData: any;
    @ViewChild("decorator") decorator: any;
    @ViewChild('formsize', { static: false }) formsize!: ElementRef; // Reference the actual component
    view: any = CalendarView.Month;
    CalendarView = CalendarView;
    summaryData: boolean = false
    viewDate: Date = new Date();
    moment = _moment;
    resourceName: any = "";
    id: any;
    modalData: {
        action: string;
        event: CalendarEvent;
    };
    refresh: Subject<any> = new Subject();
    events: CalendarEvent[] = [];
    event: any = [];
    user: any = [];
    hourSegments: number = 2; //must be divided by 60
    dayStartHour: Number = 0; dayEndHour: Number = 23; //not less than 0 not more than 23
    activeDayIsOpen: boolean = true;
    selectedSchedule: any = "CalendarView.Month"
    resourceDef: any;
    locale = {
        "locale": { "format": "MM/DD/YYYY HH:mm:ss a" }
    }
    config = {
        "submitButton": false,
        "cancelButton": false,
        "filterForm": false,
        "clearOnSave": false,
        "delegateSave": true,
        "cancelRoute": ''
    }
    title: any = "";
    scheduledOt: any;
    completedOt: any;
    formValue: any;
   // requestedOt: any;
    dayView: boolean = false;
    practice_type_code: any;
    serviceItemCode: any;
    doctorIds: any = "";
    currentTime: any;
    needToCloseSidebar: boolean = true;




    constructor(
        private modalService: SmartModalService,
        private baseService: BaseService,
        private Aroute: ActivatedRoute,
        private dialogService: DialogService,
        private dialogRef: DialogRef,
        public utilService: UtilService,
        private aside: AsideBarService,
        private alertService: AlertsService,
        private route: Router,
        private loader: LoaderService,
        private dialogConfig: DialogConfig,
        private appService: AppService,
        private communication: CommunicationService,
        private changeDetectorRef: ChangeDetectorRef,
    ) { }

    ngOnInit(): void {
        this.currentTime = this.moment().utc().valueOf();
        if (this['data'] != undefined) {
            this.resourceName = this['data']['resource']
            this.dayView = this['data']['dayView']
            this.id = this['data']['id']
            this.title = this['data']['title'];
            this.practice_type_code = this['data']['practice_type_code'];
            this.serviceItemCode = this['data']['serviceItemCode'];
        } else if (this.Aroute.snapshot.params.type != undefined) {
            this.resourceName = this.Aroute.snapshot.params.type ? this.Aroute.snapshot.params.type : "";
            this.id = this.Aroute.snapshot.params.id ? this.Aroute.snapshot.params.id : "";
            this.title = this.Aroute.snapshot.params.title ? this.Aroute.snapshot.params.title : "";
            this.baseService.backNavigation = true;
        } else if (this.input != undefined) {
            this.resourceName = this.input
            this.dayView = true;
        } else {
            this.resourceName = this.dialogConfig.resource
            this.id = this.dialogConfig['id']
            this.title = this.dialogConfig['title']
            if(this.dialogConfig['dayView'] != undefined){
                this.dayView = this.dialogConfig['dayView']
                this.serviceItemCode = this.dialogConfig['serviceItemCode'];
                this['data'] = this.dialogConfig
                this.needToCloseSidebar = this.dialogConfig['needToCloseSidebar'] != undefined ? this.dialogConfig['needToCloseSidebar'] : true;
            }
        }
        this.getresourceDef()
    }

    getresourceDef() {
        this.baseService.getResourceDef(this.resourceName, (data) => {
            this.communication.emitCalendarData(data);
            this.resourceDef = data;
            this.selectedSchedule = data.selected_view;
            if (data.timings) {
                this.dayStartHour = data.timings.start_time;
                this.dayEndHour = data.timings.end_time;
                this.hourSegments = data.timings.hour_segment == undefined ? 2 : data.timings.hour_segment;
            }
            this.baseService.setTitle(this.resourceDef.page_name.list);
        })
    }

    userEvent(event?) {
        let query_id = this.resourceDef.user.datasource.query_id == undefined ? "GET_PAGE" : this.resourceDef.user.datasource.query_id;
        let resource = this.resourceDef.user.datasource.resource == undefined ? "" : this.resourceDef.user.datasource.resource;
        let application = this.resourceDef.user.datasource.application == undefined ? "" : this.resourceDef.user.datasource.application;
        let args = this.resourceDef.user.datasource.args == undefined ? "" : this.resourceDef.user.datasource.args;
        let filter = this.resourceDef.user.datasource.filter == undefined ? "" : this.resourceDef.user.datasource.filter;
        let compositeKey = this.resourceDef.user.datasource.composite == undefined ? "" : this.resourceDef.user.datasource.composite;
        let slot_summary = this.resourceDef.user.datasource.slot_summary == undefined ? "" : this.resourceDef.user.datasource.slot_summary;
        this.baseService.get(query_id, this.makeArgs(args), resource, application, this.makeArgs(filter)).subscribe((res: any) => {
            this.loader.hideSpinner();
            if (res.errCode == 0) {
                if (res.resource.length != 0) {
                    if (compositeKey != "") {
                        res.resource = res.resource[0][compositeKey];
                        if (res.resource.length == 0) {
                            this.alertService.error('Please add favourite doctor')
                        }
                    }
                    this.user = res.resource.map(x => ({
                        id: x[this.resourceDef.user.datasource.keys_to_show.id],
                        name: x[this.resourceDef.user.datasource.keys_to_show.name],
                        color: this.resourceDef.colors[this.resourceDef.selected_color],
                        ...(!this.needToCloseSidebar ? { showTooltip: true } : {})  // any reason Tooltip is not showing then add this code 
                    }));
                    this.user.sort((a, b) => a.name.replace(/[&\/\\, +()$~%.'":*?<>{}-]/g, " ").localeCompare(b.name.replace(/[&\/\\, +()$~%.'":*?<>{}-]/g, " ")))
                    this.doctorIds = res.resource.map(x => x.doctor_id).join("#");
                    this.schedularDayEvents()
                }
                else
                    this.alertService.error('Please add favourite doctor');
            }
        });
    }
    
    calendarevents() {
        this.loader.showSpinner();
        let obj = {
            query_id : this.resourceDef.APIResource.datasource.query_id == undefined ? "GET_PAGE" : this.resourceDef.APIResource.datasource.query_id,
            filter : this.resourceDef.APIResource.datasource.filter == undefined ? "" : this.makeArgs(this.resourceDef.APIResource.datasource.filter),
            args : this.makeArgs(this.resourceDef.APIResource.datasource.args)
        }
        obj['page_size'] = this.resourceDef.APIResource.datasource.page_size ? this.resourceDef.APIResource.datasource.page_size : '';
        let resource = this.resourceDef.APIResource.datasource.resource == undefined ? "" : this.resourceDef.APIResource.datasource.resource;
        let application = this.resourceDef.APIResource.datasource.application == undefined ? "" : this.resourceDef.APIResource.datasource.application;
        this.baseService.getData(obj, "", resource, application).subscribe((res: any) => {
            this.loader.hideSpinner()
            if (res.errCode == 0) {
                if (res.resource.length != 0) {
                    this.scheduledOt = res.resource.filter(x => x.stage == "Scheduled").length;
                    this.completedOt = res.resource.filter(x => x.stage == "Completed").length;
                  //  this.requestedOt = res.resource.filter(x => x.stage == "Requested").length;
                    this.events = res.resource.map(x => {
                        return {
                            start: new Date(x[this.resourceDef.APIResource.datasource.keys_to_show.start]),
                            end: new Date(x[this.resourceDef.APIResource.datasource.keys_to_show.end]),
                            title: this.maketitle(this.resourceDef.title, x),
                            color: this.resourceDef.conditional_color != undefined ? this.makeColor(this.resourceDef.conditional_color, x) : this.resourceDef.colors[this.resourceDef.selected_color],
                            facility_id: x.facility_id,
                            doctor_id: x[this.resourceDef.APIResource.datasource.keys_to_show.doctor_id],
                            doctor_name: x[this.resourceDef.APIResource.datasource.keys_to_show.doctor_name],
                            care_type_name: x.care_type_name,
                            care_type: x.care_type,
                            facility_name: x.facility_name,
                            patient_name: x.patient_name,
                            patient_age: x.patient_age,
                            patient_gender: x.patient_gender,
                            uhId: x.uhId,
                            telecom: x.telecom,
                            encounter_id: x.encounter_id,
                            serviceItemName: x.serviceItemName,
                            currentBed: x.currentBed,
                            surgeon: x.surgeon
                        }
                    })

                } else {
                    this.events = [];
                    this.scheduledOt = 0;
                 //   this.requestedOt = '0';
                    this.completedOt = 0;
                }
            } else {
                this.alertService.error(res.message)
            }
        })
    }

    makeUser(item: any) {
        let user = this.user != undefined ? this.user.find(x => (x.id == item[this.resourceDef.user_key])) : '';
        return user
    }

    maketitle(title: any, item) {
        var str = [];
        if (Object.keys(title).length != 0) {
            str = Object.keys(title).filter(x => eval(title[x])(item) != "").map(x => { return x + " : " + eval(title[x])(item) })
            return str
        } else {
            return str
        }
    }

    closeaSidebar(slot) {
        let currentData = this.currentTime  //Conveert to miniseconds
        let passCurentTime = slot.event.end.getTime();// Convert to miniseconds  
        if (!slot.event.event.reason) {
            if (slot.event.event.status != "booked" && currentData < passCurentTime) {
                //      this.slotResult(data.data.event)
                if(this.needToCloseSidebar){
                    this.aside.removeComponent(slot);
                }
                this.modalService.sendResult(slot);
                this.dialogRef.close(slot);
            }
            else {
                this.alertService.error("Slot time is passed, kindly select another slot!")
                return false
            }
        }
        else {
            this.alertService.error("Slot not available for booking. Kindly select another slot")
        }

    }


    makeresource(data) {
        var q = {}
        Object.keys(this.resourceDef.fields).forEach((element, index) => {
            q[Object.keys(element)[index]] = data[q[Object.keys(element)[index]]]
        })
        return q;
    }

    makeColor(color, item) {
        item['currentTime'] = this.currentTime;
        for (let val of color) {
            if (eval(val.expression)) {
                return this.resourceDef.colors[val.color]
            }
        }

    }

    makeArgs(argument) {
        let str = argument;
        if (str != '') {
            let data = {
                start_date: this.view === 'week' ? this.moment(`${this.viewDate}`).startOf(this.view.toLowerCase()).day(0).valueOf() : this.moment(`${this.viewDate}`).startOf(this.view.toLowerCase()).valueOf(), // week started day in sunday bydefault started on  Monday
                end_date: this.moment(`${this.viewDate}`).endOf(this.view.toLowerCase()).valueOf(),
                id: this.id,
                day: this.moment(this.viewDate).format("dd").toUpperCase().valueOf(),
                practice_type_code: this.practice_type_code,
                serviceItemCode: this.serviceItemCode,
                care_type: this.appService.getUniversalConfig("multi_care_type") ? this.appService.getDynamicFunctions("getCurrentCareType") : "",
                speciality_id: this.formValue?.speciality_id?.speciality_id ?? '',
                appointment_mode: this.formValue.appointment_mode,
                machine_id: this.formValue.machine_id ? this.formValue.machine_id : "",
                room_name: this.formValue.room_name ? this.formValue.room_name : '',
                service_code: this.formValue.service_code ? this.formValue.service_code : '',
                subDepartment_name: this.formValue.subDepartment_name ? this.formValue.subDepartment_name : '',
                subDepartment_id: this.formValue.subDepartment_id ? this.formValue.subDepartment_id : "",
                machine_name: this.formValue.machine_name ? this.formValue.machine_name : '',
                priority_code: this.formValue?.priority_code,
                serviceType_code: this.formValue?.serviceType_code,
                facility_id : this.formValue.facility_id ? this.formValue.facility_id : ''
            }
            let result = str.match(/\!!!(.*?)\!!!/gm);
            if (result) {
                for (let i = 0; i < result.length; i++) {
                    str = str.replace(result[i], data[result[i].replace(/!!!/g, "")])
                }
            }
        }
        return str;
    }

    dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
        if (isSameMonth(date, this.viewDate)) {
            if (
                (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
                events.length === 0
            ) {
                this.activeDayIsOpen = false;
            } else {
                this.activeDayIsOpen = true;
            }
            this.viewDate = date;
        }
    }

    handleEvent(action: string, event: any): void {
        if (this.resourceDef.popup != undefined) {
            let datatoSend = { data: event, formResourec: this.resourceDef.popup }
            this.modalService.open(CalendarEventDetailComponent, datatoSend, 'Event Detail of ' + event.doctor_name, ModalSize.Lg).subscribe((res: any) => {
                console.log("res is ::", res)
            },
                (err) => {
                    console.error("Error in getting data ;;", err)
                })
        }

    }
    hourSegmentClicked(action: string, event: any) {
        let hasdata: any = "";
        for (let i = 0; i < this.user.length; i++) {
            if (i == event.data) {
                hasdata = this.user[i];
            }
        }
        console.log("dta is ", hasdata);
        if (this.resourceDef.application == 'ot') {
            this.getpatientDetails(event)
            if (hasdata != undefined) {
                this.id = hasdata.id;
                this.title = hasdata.name;
            }
        }
    }

    setView(view: CalendarView) {
        this.view = view;
        this.calendarevents()
    }

    closeOpenMonthViewDay() {
        this.activeDayIsOpen = false;
        if (this.formValue.defaultCalendar == "CalendarView.Day" && this.dayView) {
            this.userEvent()
            this.view = "day";
        }
        else
            this.calendarevents();
        // if (!(this.formValue.defaultCalendar == "CalendarView.Day" && this.resourceDef.user != undefined && this.resourceDef.user.datasource.application == 'ot')) {
        //     this.calendarevents()
        // }

    }

    previous() {
        if (this.Aroute.snapshot.queryParams.returnUrl != undefined) {
            this.route.navigateByUrl(`${this.Aroute.snapshot.queryParams.returnUrl}`)
        } 
        else
            window.history.back();
    }

    scheduleChange(event: any) {
        if (event == "CalendarView.Month")
            this.setView(CalendarView.Month)
        else if (event == "CalendarView.Week")
            this.setView(CalendarView.Week)
        else if (event == "CalendarView.Day")
            this.setView(CalendarView.Day)
    }

    schedulerChange(event: any) {
        this.formValue = event.form.value;
        if (this['data']?._khaliobj) {
            this.formValue = {...this['data']._khaliobj,...this.formValue  };
        }
        if (event.question != undefined && event.question.question.key == "partOf" && this.formValue && this.formValue.partOf) {
            this.id = this.formValue.partOf;
            this.title = this.formValue.partOfName;
            this.scheduleChange(this.formValue.defaultCalendar)
        }
        else  if (event.question != undefined && event.question.question.key == "surgeon_id" && this.formValue && this.formValue.surgeon_id ) {
            this.resourceDef.dayDatasource.datasource.filter = "surgeon_id:"+this.formValue.surgeon_id;
            this.resourceDef.APIResource.datasource.filter = "surgeon_id:"+this.formValue.surgeon_id;
            this.formValue.defaultCalendar != "CalendarView.Day" ? this.calendarevents():this.schedularDayEvents();
        }
        else  if (event.question != undefined && event.question.question.key == "surgeon_id" && this.formValue && !this.formValue.surgeon_id ) {
            this.resourceDef.dayDatasource.datasource.filter = '';
            this.resourceDef.APIResource.datasource.filter = '';
            this.formValue.defaultCalendar != "CalendarView.Day" ? this.calendarevents():this.schedularDayEvents();
        }
        else if (event.question != undefined && event.question.question.key == "defaultCalendar" && ((!this.formValue.partOf && this.formValue.defaultCalendar != "CalendarView.Day") || (this.id != undefined && this.id != ""))) {
            this.scheduleChange(this.formValue.defaultCalendar)
        }
        else if (event.question != undefined && event.question.question.key == "defaultCalendar" && this.formValue.defaultCalendar == "CalendarView.Day") {
          this.userEvent();
            this.view = "day";
        }


    }
    schedularDayEvents() {
        this.loader.showSpinner()
        this.title = undefined;
        let obj = {};
        let arr = [];
        obj['query_id'] = this.resourceDef.dayDatasource.datasource.query_id == undefined ? "GET_PAGE" : this.resourceDef.dayDatasource.datasource.query_id;
        let resource = this.resourceDef.dayDatasource.datasource.resource == undefined ? "" : this.resourceDef.dayDatasource.datasource.resource;
        let application = this.resourceDef.dayDatasource.datasource.application == undefined ? "" : this.resourceDef.dayDatasource.datasource.application;
        obj["args"] = this.resourceDef.dayDatasource.datasource.args == undefined ? this.makeArgs("start_date:!!!start_date!!!,end_date:!!!end_date!!!") : this.makeArgs(this.resourceDef.dayDatasource.datasource.args);
        obj["filter"] = this.resourceDef.dayDatasource.datasource.filter == undefined ? this.doctorIds : this.resourceDef.dayDatasource.datasource.filter;
        obj['page_size'] = this.resourceDef.dayDatasource.datasource.page_size ? this.resourceDef.dayDatasource.datasource.page_size : '';
        this.baseService.getData(obj, "", resource, application).subscribe((res: any) => {
            this.loader.hideSpinner()
            if (res.errCode == 0) {
                if (res.resource.length != 0) {
                    if (application == 'ot') {
                        arr = res.resource
                    }
                    else if (application == 'facility-management') {
                        if (res?.resource?.[0]?.extra_data?.calendar_slot?.slot_time) {
                            for (let i = 0; i < res.resource.length; i++) {
                                if (res.resource[i].extra_data.calendar_slot.slot_time != undefined) {
                                    arr.push(...res.resource[i].extra_data.calendar_slot.slot_time);
                                }
                            }
                        } else {
                            arr = res.resource
                        }
                    }
                    this.scheduledOt = res.resource.filter(x => x.stage == "Scheduled").length;
                    this.completedOt = res.resource.filter(x => x.stage == "Completed").length;
                   // this.requestedOt = res.resource.filter(x => x.stage == "Requested" && x.ot_id != undefined && x.ot_name != undefined).length;
                    this.event = arr.map(x => {
                        return {
                            start: new Date(x[this.resourceDef.dayDatasource.datasource.keys_to_show.start]),
                            end: new Date(x[this.resourceDef.dayDatasource.datasource.keys_to_show.end]),
                            title: this.maketitle(this.resourceDef.title, x),
                            color: this.resourceDef.conditional_color != undefined ? this.makeColor(this.resourceDef.conditional_color, x) : this.resourceDef.colors[this.resourceDef.selected_color],
                            facility_id: x.facility_id,
                            doctor_id: x[this.resourceDef.dayDatasource.datasource.keys_to_show.doctor_id],
                            doctor_name: x[this.resourceDef.dayDatasource.datasource.keys_to_show.doctor_name],
                            facility_name: x.facility_name,
                            care_type_name: x.care_type_name,
                            patient_name: x.patient_name,
                            patient_gender: x.patient_gender,
                            patient_age: x.patient_age,
                            uhId: x.uhId,
                            encounter_id: x.encounter_id,
                            serviceItemName: x.serviceItemName,
                            slotId: x.slotId,
                            reason: x.reason,
                            slotNo: x.slotNo,
                            doctor_code: x.doctor_code,
                            slot_date: x.slot_date,
                            event: x,
                            floor_name: x.floor_name,
                            slot_start_time: x.slot_start_time,
                            slot_end_time: x.slot_end_time,
                            schedule_id: x.schedule_id,
                            partOfName: x.partOfName,
                            slot_over_booking_status: x.slot_over_booking_status ? x.slot_over_booking_status : false,
                            over_booking_status: x.over_booking_status,
                            waiting_status: x.waiting_booking ? x.waiting_booking : false,
                            surgeon: x.surgeon,
                            telecom: x.telecom,
                            currentBed: x.currentBed,
                            machine_id:x.machine_id,
                            machine_name:x.machine_name,
                            custom_tooltip_dataSource : this.resourceDef?.toolTipDatasource?.datasource,
                            custom_tootip_key_to_show : this.resourceDef?.toolTipDatasource?.datasource?.keys_to_show,
                            serviceTypeCode: x.machine_id === this.formValue.machine_id ? this.formValue.serviceType_code : undefined,
                            meta: {
                                user: this.makeUser(x)
                            }
                        }
                    })
                } else {
                    this.event = [];
                    this.scheduledOt = 0;
                 //   this.requestedOt = '0';
                    this.completedOt = 0;
                }
            }else {
                if (this.resourceDef?.dayDatasource?.datasource?.holidayPopupInfo) {
                    this.alertService.info(res.message);
                } else {
                    this.alertService.error(res.message);
                }
            }
        })
    }
    checkPage() {
        return this.Aroute.snapshot.params.type == undefined ? false : true
    }

    onChange(event) {
        this.viewDate = new Date(event.startDate);
        this.closeOpenMonthViewDay()
    }

    getpatientDetails(slot) {
        let obj = {
            "label": "field.label.search_patient",
            "hint": "field.hint.fieldAdmitNew",
            "type": "search",
            "datasource": {
                "application": "adt",
                "resource": "encounter_ipAdmission",
                "query_id": "GET_ADMITTED_PATIENT_LIST",
                "template": "<div class='u-search-items position-relative border-bottom pl-3 pr-3 pb-1 pt-1'><div class='u-name'><span>!!!patient_name!!!</span><span class='u-preRegistrationNo txt-13 pl-2 pr-1'>!!!preRegistrationNo!!!</span></div><span class='u-uhid txt-13 pl-2'>!!!uhId!!!</span><span class='u-age txt-13 pl-2'>!!!patient_age!!!</span><span class='u-gender txt-13'>!!!patient_gender!!!</span><br></div>"
            },
            "fields": [
                "patient_name",
                "uhId",
                "preRegistrationNo",
                "patient_age",
                "patient_gender"
            ],
            "fixLabel": {
                "popup": {
                    "redirectLink": "/ot/surgery_request_op/add"
                }
            }
        }
        let popobj = { data: obj, title: 'Search and add patient', size: DialogModalSize.Md };
        this.dialogService.open(SearchPatientComponent, popobj).afterClosed.subscribe(
            response => {
                console.log("response is :: ", response);
                if (response != undefined) {
                    console.log(response);
                    let key = response.id;
                    this.route.navigateByUrl("/ot/" + this.resourceDef.addResource + "/add?key=" + key + "&start_time=" + slot.date + "&viewDate=" + this.viewDate + "&partOf=" + this.id + "&partOfName=" + this.title + "&source=calendar&returnUrl=%2Fot%2F" + this.resourceDef.returnResource + "%2Flist");
                }
                this.dialogRef.close()
            }
        );
    }

}
